import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React, { useEffect, useState } from "react";
import styles from "./PaymentMethodBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import {
  setPaymentMethodsAction,
  setSelectedPaymentMethodAction,
  togglePaymentMethodsModalAction,
  toggleMultiPaymentMethodModalAction,
  setSelectedMultiPaymentMethodAction
} from "../../store/actions";
import { PAYMENT_GATWAY_ENUMS } from "@src/PaymentService/constants";
import { initialisePaymentService, retryPayment } from "@src/PaymentService";
import { setRetryingPayment } from "../../../Tabs/Overview/store/actions";

const PaymentMethodBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const prevOrderId = useSelector(
    (state) => state?.overviewReducer?.prevOrderId
  );
  const retryingPayment = useSelector((state) => state?.overviewReducer?.retryingPayment)
  const comboCourseIds = useSelector(
    (state) => state?.overviewReducer?.comboCourseList || []
  );
  const comboId = useSelector( (state) => state?.overviewReducer?.comboCourseId || null);
  return (
    <>
      {
        <div className={styles.AllStates}>
          <Modal
            // showModal={isDynamicBundling}
            handleClose={() => {
                dispatch(actionCreator.idfysPaymentRejectedAction())
                dispatch(togglePaymentMethodsModalAction(false));
                dispatch(  toggleMultiPaymentMethodModalAction(false));
                dispatch(setPaymentMethodsAction(null));
                dispatch(setSelectedMultiPaymentMethodAction(null));
                dispatch(setRetryingPayment(false))
            }}
            header={
              <div className={styles.AllStates__header}>
                {t(
                  "components.bottomSheets.components.PaymentMethodBottomSheet.chooseHowYouWantToPay",
                  "Choose how you want to pay"
                )}
              </div>
            }
          >
            <div className={styles.AllStates__States}>
              <div className={styles.AllStates__States__optionWrapper}
                onClick={
                  () => {
                    dispatch(setSelectedMultiPaymentMethodAction(PAYMENT_GATWAY_ENUMS.RAZORPAY));
                    retryingPayment ? retryPayment(prevOrderId, false) : initialisePaymentService(comboCourseIds, comboId);
                    dispatch(setRetryingPayment(false))
                  }
                }
              >
                <Image
                  //  src={getAwsAssets("MultiPaymentOption.svg", "bottomSheets")}
                  src={
                    "https://cdn-wl-assets.classplus.co/frontend-assets/MultiPaymentOption.svg"
                  }
                  className="SVGCoupons"
                  height="100%"
                  width="100%"
                  alt={t(
                    "components.bottomSheets.components.PaymentMethodBottomSheet.MultiPaymentOption",
                    "MultiPaymentOption"
                  )}
                />
              </div>
              <div className={styles.AllStates__States__optionWrapper}
               onClick={
                () => {
                  dispatch(setSelectedMultiPaymentMethodAction(PAYMENT_GATWAY_ENUMS.RAZORPAY_QR));
                  retryingPayment ? retryPayment(prevOrderId, true) : initialisePaymentService(comboCourseIds, comboId);
                  dispatch(setRetryingPayment(false))
                }
              }
              >
                <Image
                  //  src={getAwsAssets("QrPayment.svg", "bottomSheets")}
                  src={
                    "https://cdn-wl-assets.classplus.co/frontend-assets/payViaQR.svg"
                  }
                  className="SVGCoupons"
                  height="100%"
                  width="100%"
                  alt={t(
                    "components.bottomSheets.components.PaymentMethodBottomSheet.payViaQR",
                    "payViaQR"
                  )}
                />
              </div>
            </div>
          </Modal>
        </div>
      }
    </>
  );
};

export default PaymentMethodBottomSheet;
